import React from 'react';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import CssBaseline from '@material-ui/core/CssBaseline';
import { Button, Container, Grid, OutlinedInput, Typography, withStyles } from '@material-ui/core';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import queryString from 'querystring';
import KakaoLogin from 'react-kakao-login';
//import NaverLogin from 'react-naver-login';
import GoogleLogin from 'react-google-login';
import { API_URL, GOOGLE_KEY, KAKAO_KEY, NAVER_CALLBACK, NAVER_KEY } from '../common/Constants';
import axios from 'axios';
import swal from '@sweetalert/with-react';

const styles = (theme) => ({
  bg: {
    backgroundImage: 'linear-gradient( rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5) ),url("/images/stamptour_bg.jpg")',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center 70%',
    backgroundSize: 'cover',
    width: '100%',
    height: '100%',
    overflowY: 'auto',
    position: 'absolute',
    wordBreak: 'keep-all',
    [theme.breakpoints.down('sm')]: {
      backgroundPosition: '66% bottom',
    },
    '& fieldset': {
      borderWidth: 0, // fix IE
    },
  },
  container: {
    width: '100%',
    height: '100%',
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      padding: 0,
    },
  },
  paper: {
    textAlign: 'center',
    position: 'absolute',
    top: '50%',
    transform: 'translate(0, -50%)',
    [theme.breakpoints.down('sm')]: {
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: '80%',
    },
  },
  cardContent: {
    padding: theme.spacing(3, 5),
  },
  outerGrid: {
    textAlign: 'center',
  },
  logo: {
    width: 100,
    height: 100,
    marginBottom: theme.spacing(3),
    cursor: 'pointer',
    WebkitTouchCallout: 'none',
  },
  loginTextDiv: {
    display: 'inline-block',
    borderBottom: `5px solid ${theme.palette.primary.main}`,
    fontSize: '2em',
    fontWeight: 700,
    marginBottom: theme.spacing(2),
  },
  inputRoot: {
    borderRadius: 25,
    boxShadow: 'inset 0px 2px 2px 0 rgba(0, 0, 0, 0.04)',
    backgroundColor: '#f2f2f2',
    borderStyle: 'none',
    marginBottom: theme.spacing(1.5),
  },
  inputInput: {
    padding: theme.spacing(1.5, 2.5),
  },
  //버튼
  submitBtn: {
    margin: theme.spacing(1, 0, 2),
    backgroundColor: theme.palette.primary.main,
    borderRadius: 30,
    color: '#fff',
    fontSize: '1.2em',
    fontWeight: 900,
  },
  joinBtn: {
    color: theme.palette.primary.point,
    cursor: 'pointer',
    textDecoration: 'underline',
    fontWeight: 600,
  },
  snsIcon: {
    width: '4em',
    height: '4em',
    border: '1px solid #eaeaea',
    borderRadius: '100%',
    padding: 15,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    '& img': {
      width: '1.8em',
      height: '1.8em',
    },
    '&:nth-child(2)': {
      '@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)': {
        display: 'none',
      },
    },
    // IE justifyContent: 'space-evenly' 미지원
    '&:nth-child(1)': {
      '@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)': {
        margin: '0px 10px',
      },
    },
    '&:nth-child(3)': {
      '@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)': {
        margin: '0px 10px',
      },
    },
  },

  goBackBtnText1: {
    fontSize: '1em',
    display: 'inline',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
  goBackBtnText2: {
    fontSize: '1em',
    display: 'inline',
    paddingLeft: '1em',
    paddingRight: '1em',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  goBackBtnText3: {
    fontSize: '1em',
    display: 'inline',
    cursor: 'pointer',
    textDecoration: 'underline',
    [theme.breakpoints.down('sm')]: {
      paddingTop: '0.5em',
      display: 'block',
    },
  },
});

class LoginPage extends React.Component {
  constructor(props) {
    super(props);
    let param = queryString.parse(this.props.location.search.replace('?', ''));
    let tokenParam = queryString.parse(this.props.location.hash.replace('#', ''));

    // for Naver Login

    if (props.location.hash.indexOf('access_token') !== -1) {
      // console.log('GO Naver Callback', `${API_URL}/naverCallback?token=${tokenParam.access_token}`);
      axios
        .get(`${API_URL}/naverCallback?token=${tokenParam.access_token}`, param, { headers: { Pragma: 'no-cache' } })
        .then((response) => {
          this.snsLogin('naver', response.data.response);
        })
        .catch((err) => {
          console.log('naver error');
          console.log(err);
        })
        .finally(() => {});
    }
    this.state = {
      email: '',
      password: '',
      ref: param.ref,
      stampId: param.stampId,
      courseId: param.courseId,
      matches: window.matchMedia('(max-width:960px)').matches,
    };

    if (param.stampId && param.courseId) {
      sessionStorage.setItem('stampId', param.stampId);
      sessionStorage.setItem('courseId', param.courseId);
    }

    this.handleChange = this.handleChange.bind(this);
    this.handleSignIn = this.handleSignIn.bind(this);
  }

  componentDidMount() {
    const login = new window.naver.LoginWithNaverId({
      clientId: NAVER_KEY,
      callbackUrl: NAVER_CALLBACK,
      isPopup: false,
      loginButton: { color: 'green', type: 1, height: 25 },
      callbackHandle: true,
    });
    login.init();

    const evtTarget = document.getElementById('password');
    evtTarget.addEventListener('keydown', (event) => {
      if (event.keyCode === 13) {
        this.submit();
      }
    });
  }

  componentWillUnmount() {
    const evtTarget = document.getElementById('password');
    evtTarget.removeEventListener('keydown', (event) => {
      if (event.keyCode === 13) {
        this.submit();
      }
    });
  }

  handleSignIn(event) {
    event.preventDefault();
  }

  handleChange(type, e) {
    this.setState({ [type]: e.target.value });
  }

  snsLogin(type, res) {
    let param = null;
    if (type === 'kakao') {
      param = {
        sid: '' + res.profile.id,
        st: type,
        password: '' + res.profile.id,
        name: res.profile.kakao_account.profile.nickname,
        email: res.profile.kakao_account.email,
        img: res.profile.kakao_account.profile.profile_image_url || '',
        birthday: res.profile.kakao_account.birthday || '',
        gender: res.profile.kakao_account.gender || '',
        age_range: res.profile.kakao_account.age_range || '',
      };
    } else if (type === 'google') {
      param = {
        sid: '' + res.googleId,
        st: type,
        password: '' + res.googleId,
        name: res.profileObj.name || '',
        email: res.profileObj.email,
        img: res.profileObj.imageUrl || '',
      };
    } else if (type === 'naver') {
      param = res;
      param['sid'] = '' + res.id;
      param['st'] = type;
      param['password'] = '' + res.id;
      param['name'] = res.name || '';
      param['email'] = res.email;
      param['phone'] = res.mobile || '';
      console.log(param);
    }

    if (param) {
      axios
        .post(`${API_URL}/register`, param, { headers: { Pragma: 'no-cache' } })
        .then((response) => {
          console.log('1');
          this.doLogin(param.email, '' + param.password);
        })
        .catch((err) => {
          if (err.response && err.response.status === 308) {
            console.log('2');
            if (err.response.data.obj.st !== type) {
              console.log('3');
              // 다른 sns로 이미 가입한 사람
              swal('이미 가입하신 이메일주소입니다.').then(() => {
                window.opener = 'Self';
                window.open('', '_parent', '');
                window.close(); // 일반적인 현재 창 닫기
              });
            } else {
              console.log('4');
              console.log(param.email);
              console.log(param.password);
              console.log(type);
              this.doLogin(param.email, '' + param.password, type);
            }
          }
        });
    }
  }

  doLogin(email, password, type) {
    const param = {
      email: email,
      password: password,
    };
    axios
      .post(`${API_URL}/login`, param, { headers: { Pragma: 'no-cache' } })
      .then((response) => {
        // console.log(response);
        if (response.status === 200) {
          if (response.data.success === true) {
            localStorage.setItem('st_token', response.data.token);
            localStorage.setItem('refreshToken', response.data.refreshToken);

            let buff = {
              name: response.data.userInfo.name,
              course: response.data.userInfo.course,
              stamp: response.data.userInfo.stamp,
            };

            localStorage.setItem(`loggedin`, response.data.userInfo.id);
            localStorage.setItem(`${response.data.userInfo.id}_status`, JSON.stringify(buff));

            if (this.state.stampId) {
              axios
                .get(`${API_URL}/course/qrStamp?stampId=${this.state.stampId}&courseId=${this.state.courseId}`, {
                  headers: { Pragma: 'no-cache', Authorization: `${localStorage.getItem('st_token')}` },
                })
                .then((response) => {
                  swal({
                    text: '스탬프가 발급되었습니다.',
                    button: '확인',
                  }).then(() => {
                    this.props.history.replace(`/mypage?course=${this.state.courseId}&stamp=${this.state.stampId}`);
                  });
                })
                .catch((err) => {
                  console.log(err);
                  swal({
                    text: '이미 발급된 스탬프입니다.',
                    button: '확인',
                  }).then(() => {
                    this.props.history.replace(`/mypage?course=${this.state.courseId}`);
                  });
                });
            } else {
              console.log('type', type);
              if (type === 'naver' || type === undefined) {
                if (type === 'naver' && sessionStorage.getItem('stampId')) {
                  axios
                    .get(
                      `${API_URL}/course/qrStamp?stampId=${sessionStorage.getItem('stampId')}&courseId=${sessionStorage.getItem(
                        'courseId',
                      )}`,
                      {
                        headers: { Pragma: 'no-cache', Authorization: `${localStorage.getItem('st_token')}` },
                      },
                    )
                    .then((response) => {
                      swal({
                        text: '스탬프가 발급되었습니다.',
                        button: '확인',
                      }).then(() => {
                        sessionStorage.setItem('stampId', '');
                        this.props.history.replace(
                          `/mypage?course=${sessionStorage.getItem('courseId')}&stamp=${sessionStorage.getItem('stampId')}`,
                        );
                      });
                    })
                    .catch((err) => {
                      console.log(err);
                      swal({
                        text: '이미 발급된 스탬프입니다.',
                        button: '확인',
                      }).then(() => {
                        sessionStorage.setItem('stampId', '');
                        this.props.history.replace(`/mypage?course=${sessionStorage.getItem('courseId')}`);
                      });
                    });
                } else {
                  window.opener = 'Self';
                  window.open('', '_parent', '');
                  window.close(); // 일반적인 현재 창 닫기
                  this.props.history.replace('/');
                  setTimeout(function () {
                    window.location.reload();
                  }, 1000);
                }
              } else if (type === 'google') {
                this.props.history.replace('/');
                setTimeout(function () {
                  window.location.reload();
                }, 1000);
              } else {
                this.props.history.replace('/');
              }
            }
          }
        }
      })
      .catch((err) => {
        console.log(err);
        if (err.response.data.msg === 'PASSWORD_AUTHENTICATION_FAILURE') {
          swal({
            text: '아이디 혹은 비밀번호가 일치하지 않습니다.',
            button: '확인',
          });
          return;
        } else if (err.response.data.msg === 'USER_NOT_FOUND') {
          swal({
            text: '일치하는 가입 정보가 없습니다.',
            button: '확인',
          }).then(() => {
            if (type === 'stamptour') {
              this.setState({ email: '', password: '' });
            }
          });
          return;
        }
      });
  }

  submit() {
    if (this.state.email === '') {
      swal({
        text: '이메일을 입력해주세요.',
        button: '확인',
      }).then(() => {
        document.getElementById('email').focus();
      });
      return;
    } else if (this.state.password === '') {
      swal({
        text: '비밀번호를 입력해주세요.',
        button: '확인',
      }).then(() => {
        document.getElementById('password').focus();
      });
      return;
    } else {
      this.doLogin(this.state.email, this.state.password, 'stamptour');
    }
  }

  handleNaverLogin = () => {
    if (document && document?.querySelector('#naverIdLogin')?.firstChild && window !== undefined) {
      const loginBtn = document.getElementById('naverIdLogin')?.firstChild;
      loginBtn.click();
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <CssBaseline />
        <div className={classes.bg}>
          <Container maxWidth="xs" className={classes.container}>
            <div className={classes.paper}>
              <Card style={{ borderRadius: 20 }}>
                <CardContent className={classes.cardContent}>
                  <img
                    src={'/images/doowon_logo_color@2x.png'}
                    className={classes.logo}
                    alt={'doowon_logo'}
                    onClick={() => {
                      this.props.history.push('/');
                    }}
                    onContextMenu={(e) => e.preventDefault()}
                  />
                  <OutlinedInput
                    required
                    fullWidth
                    id="email"
                    type="email"
                    name="email"
                    placeholder="Email"
                    classes={{
                      root: classes.inputRoot,
                      input: classes.inputInput,
                      //focused: classes.focusedInput,
                    }}
                    onChange={(e) => {
                      this.handleChange('email', e);
                    }}
                    value={this.state.email}
                  />
                  <OutlinedInput
                    required
                    fullWidth
                    id="password"
                    type="password"
                    name="password"
                    placeholder="Password"
                    classes={{
                      root: classes.inputRoot,
                      input: classes.inputInput,
                    }}
                    onChange={(e) => {
                      this.handleChange('password', e);
                    }}
                    value={this.state.password}
                  />
                  <Button fullWidth disableElevation variant="contained" className={classes.submitBtn} onClick={() => this.submit()}>
                    로그인
                  </Button>
                  <Typography className={classes.goBackBtnText1}>
                    처음이신가요?{' '}
                    <span className={classes.joinBtn} onClick={() => this.props.history.push('join')}>
                      가입하기
                    </span>
                  </Typography>
                  <Typography className={classes.goBackBtnText2}>|</Typography>
                  <Typography className={classes.goBackBtnText3} onClick={() => this.props.history.push('/')}>
                    메인으로 돌아가기
                  </Typography>
                </CardContent>
              </Card>
              <Grid container style={{ padding: '1em 0' }}>
                <Grid item container xs={4} style={{ alignItems: 'center' }}>
                  <Typography style={{ width: '100%', borderRight: '1px solid #eaeaea', color: '#eaeaea' }}>
                    간편 <span style={{ fontWeight: 'bold' }}>로그인</span>
                  </Typography>
                </Grid>
                <Grid item container xs={8} style={{ justifyContent: 'space-evenly' }}>
                  <div className={classes.snsIcon} onClick={this.handleNaverLogin}>
                    <img src={'/images/login/naver_ic@2x.png'} alt={'naver'} style={{ WebkitTouchCallout: 'none' }} />
                    <div id="naverIdLogin" style={{ visibility: 'hidden', position: 'absolute' }} />
                  </div>

                  {/*
                  <NaverLogin
                    clientId={NAVER_KEY}
                    callbackUrl={NAVER_CALLBACK}
                    render={(props) => (
                      <div className={classes.snsIcon} onClick={props.onClick}>
                        <img src={'/images/login/naver_ic@2x.png'} alt={'naver'} style={{ WebkitTouchCallout: 'none' }} />
                      </div>
                    )}
                    onSuccess={(res) => {
                      // console.log(res);
                    }}
                    onFailure={() => console.log('naver login fail')}
                    onContextMenu={(e) => e.preventDefault()}
                  />*/}
                  <KakaoLogin
                    token={KAKAO_KEY}
                    onSuccess={(res) => {
                      this.snsLogin('kakao', res);
                    }}
                    onFail={console.error}
                    onLogout={console.info}
                    render={({ onClick }) => {
                      return (
                        <div
                          className={classes.snsIcon}
                          onClick={(e) => {
                            e.preventDefault();
                            onClick();
                          }}
                        >
                          <img
                            src={'/images/login/kakao_ic@2x.png'}
                            alt={'kakao'}
                            style={{ WebkitTouchCallout: 'none' }}
                            onContextMenu={(e) => e.preventDefault()}
                          />
                        </div>
                      );
                    }}
                  />
                  <GoogleLogin
                    clientId={GOOGLE_KEY}
                    render={(renderProps) => (
                      <div className={classes.snsIcon} onClick={renderProps.onClick} disabled={renderProps.disabled}>
                        <img
                          src={'/images/login/google_ic@2x.png'}
                          alt={'google'}
                          style={{ WebkitTouchCallout: 'none' }}
                          onContextMenu={(e) => e.preventDefault()}
                        />
                      </div>
                    )}
                    onSuccess={(res) => this.snsLogin('google', res)}
                    onFailure={() => console.log('google login fail')}
                    cookiePolicy={'single_host_origin'}
                  />
                </Grid>
              </Grid>
            </div>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default withStyles(styles, { withTheme: true })(LoginPage);
